
const filters = document.querySelectorAll('.category-filter');

filters.forEach((filter) => {
    filter.addEventListener('input', ()=> {
        filter.form.requestSubmit();
    })
})